// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"60881f1c","369":"84feae09","395":"7f1f00d2"}[chunkId] + ".chunk.js";
};